import { Component, Input } from '@angular/core';
import { isNilOrEmpty } from 'helpers';

interface EntityTypeInput {
  __typename: string;
  namePlural: string;
}

interface EntityConnectionTypeInput {
  __typename: string;
  entityType1: EntityTypeInput;
  entityType2: EntityTypeInput;
}

/**
 * Displays name for a connection type
 */
@Component({
  selector: 'app-type-name-label',
  template: `
    <span class="capitalize" *ngIf="isEntityConnectionType">{{type?.entityType1?.namePlural}}
    <i class="fal fa-plus"></i>
    {{type?.entityType2.namePlural}}</span>
    <span *ngIf="isEntityType">
      {{type.namePlural | propercase}}
    </span>
    `
})
export class TypeNameLabelComponent {
  @Input() type: EntityTypeInput | EntityConnectionTypeInput;

  get isEntityConnectionType() {
    return this.type && isNilOrEmpty(this.type['namePlural']);
  }

  get isEntityType() {
    return this.type && !isNilOrEmpty(this.type['namePlural']);
  }
}
